export default __webpack_public_path__ + "static/media/Travelling-hover.7ed0e62d.svg";